import React from "react";
import "./profile.css";
import ReactDOM from "react-dom/client";
import Profile_sending from "./Axios.js";
import { BibleText } from "./BibleText/BibleText.js";
import { UploadPic } from "./UploadPic/UploadPic.js";
import { UploadBackgroundPic } from "./UploadBackgroundPic/UploadBackgroundPic.js";
import StorageBox from "Store/StorageBox.js";
import UserChecker from "Utility/UserChecker.js";
import StorageKeys from "Utility/StorageKey.js";
export class Settings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      display: "inline-flex",
      loading_display: "none",
      IsChristian: UserChecker.IsChristian(),
      UserName: "",
    };
    this.finishing = this.finishing.bind(this);
  }

  componentDidMount() {
    this.initializer();
  }

  initializer() {
    var item = StorageBox.getUserData();
    console.log(item);

    sessionStorage.removeItem("p_formData");
    sessionStorage.removeItem("p_formData_background");
    document.getElementById("fullname").value = item.UserName;
    this.setState({ UserName: item.UserName });
    document.getElementById("email").value = item.email;
    document.getElementById("highLight").value = item.UserIntroduction;
    document.getElementById("user_paragraph_form").value = item.UserParagraph;
    document.getElementById("i_location").value = item.UserCountry;
    // var wat = UserChecker.IsChristian();

    if (this.state.IsChristian) {
      document.getElementById("i_bibleVerse").innerHTML = item.BibleVerse;
    } else {
      document.getElementById("i_quotes").innerHTML = item.UserQuotes;
    }
    //  document.getElementById("i_Facebook").value =
    //    document.getElementById("i_instagram").value =
    //    document.getElementById("i_Twitter").value =
    //document.getElementById("i_bibleVerse").innerHTML =
  }

  finishing() {
    this.setState({ display: "none" });
    this.setState({ loading_display: "inline-flex" });
    /* var userSocialmedia_container = {
      i_Facebook: document.getElementById("i_Facebook").value,
      i_instagram: document.getElementById("i_instagram").value,
      i_twiter: document.getElementById("i_Twitter").value,
    };
    userSocialmedia_container = JSON.stringify(userSocialmedia_container);*/
    if (this.state.IsChristian) {
      var data = {
        UserName: document.getElementById("fullname").value,
        userEmail: document.getElementById("email").value,
        userHighlight: document.getElementById("highLight").value,
        userParagraph: document.getElementById("user_paragraph_form").value,
        bibleVerse: document.getElementById("i_bibleVerse").innerHTML,
        userLocation: document.getElementById("i_location").value,
      };
    } else {
      var data = {
        UserName: document.getElementById("fullname").value,
        userEmail: document.getElementById("email").value,
        userHighlight: document.getElementById("highLight").value,
        userParagraph: document.getElementById("user_paragraph_form").value,
        userLocation: document.getElementById("i_location").value,
        UserQuotes: document.getElementById("i_quotes").innerHTML,
      };
    }
    if (sessionStorage.getItem(StorageKeys.PictureProfile) != null) {
      var profile_name = "profile_" + this.state.UserName;
      console.log("profile");
      Profile_sending.uploadProfileImage(
        sessionStorage.getItem(StorageKeys.PictureProfile),
        profile_name
      ).then((promiseResult) => {
        console.log(promiseResult);
        if (promiseResult == 200) {
          setTimeout(() => {
            window.location.href = "./profile";
          }, 3000);
        }
      });
    }

    if (sessionStorage.getItem(StorageKeys.PictureBackground) != null) {
      var background_name = "background_" + this.state.UserName;
      var formData = new FormData();
      console.log("background");
      formData.append(
        "imageData",
        sessionStorage.getItem("p_formData_background")
      );
      Profile_sending.uploadBackgoundImage(
        sessionStorage.getItem(StorageKeys.PictureBackground),
        background_name
      ).then((promiseResult) => {
        console.log(promiseResult);
        if (promiseResult == 200) {
          setTimeout(() => {
            window.location.href = "./profile";
          }, 3000);
        }
      });
    }

    if (this.state.IsChristian) {
      Profile_sending.Update_profile(data).then((promiseResult) => {
        console.log(promiseResult);
        if (promiseResult) {
          sessionStorage.removeItem("p_formData");
          sessionStorage.removeItem(StorageKeys.PictureBackground);
          window.location.href =
            sessionStorage.getItem("u_profile") + "?profile=true";
        }
      });
    } else {
      Profile_sending.Update_ProfileNotChristian(data).then((promiseResult) => {
        console.log(promiseResult);
        if (promiseResult) {
          sessionStorage.removeItem("p_formData");
          sessionStorage.removeItem(StorageKeys.PictureBackground);
          window.location.href =
            sessionStorage.getItem("u_profile") + "?profile=true";
        }
      });
    }
  }

  update_bibleVerse() {
    document.getElementById("black_container").innerHTML = "";
    var v = document.createElement("div");
    v.id = "container_verse";
    v.className = "h-full flex items-center justify-center";
    v.setAttribute("name", "container");

    document.getElementById("black_container").style.display = "block";
    document.getElementById("black_container").appendChild(v);
    var container = React.createElement(BibleText, {}, null);
    const root = ReactDOM.createRoot(v);
    root.render(container);
  }

  update_profile() {
    document.getElementById("black_container").innerHTML = "";
    var v = document.createElement("div");
    v.id = "container_verse";
    v.className = "h-full flex items-center justify-center";
    v.setAttribute("name", "container");

    document.getElementById("black_container").style.display = "block";
    document.getElementById("black_container").appendChild(v);
    var container = React.createElement(UploadPic, {}, null);
    const root = ReactDOM.createRoot(v);
    root.render(container);
  }

  update_Quotes() {
    document.getElementById("black_container").innerHTML = "";
    var v = document.createElement("div");
    v.id = "container_quotes";
    v.className = "h-full flex items-center justify-center";
    v.setAttribute("name", "container");

    document.getElementById("black_container").style.display = "block";
    document.getElementById("black_container").appendChild(v);

    // Create the quotes update interface
    const quotesInterface = (
      <div className="w-96 rounded-lg bg-white p-6 shadow-xl">
        <h3 className="mb-4 text-lg font-semibold">Update Your Quote</h3>
        <textarea
          className="mb-4 h-32 w-full rounded-md border p-2 focus:outline-none focus:ring-2 focus:ring-indigo-400"
          placeholder="Enter your favorite quote..."
          id="quotes_input"
        />
        <div className="flex justify-end gap-2">
          <button
            className="px-4 py-2 text-gray-600 hover:text-gray-800"
            onClick={() => {
              document.getElementById("black_container").style.display = "none";
            }}
          >
            Cancel
          </button>
          <button
            className="rounded-md bg-indigo-400 px-4 py-2 text-white hover:bg-indigo-500"
            onClick={() => {
              const newQuote = document.getElementById("quotes_input").value;
              document.getElementById("i_quotes").innerHTML = newQuote;
              document.getElementById("black_container").style.display = "none";
            }}
          >
            Save
          </button>
        </div>
      </div>
    );

    const root = ReactDOM.createRoot(v);
    root.render(quotesInterface);
  }

  update_background() {
    document.getElementById("black_container").innerHTML = "";
    var v = document.createElement("div");
    v.id = "container_verse";
    v.className = "h-full flex items-center justify-center";
    v.setAttribute("name", "container");

    document.getElementById("black_container").style.display = "block";
    document.getElementById("black_container").appendChild(v);
    var container = React.createElement(UploadBackgroundPic, {}, null);
    const root = ReactDOM.createRoot(v);
    root.render(container);
  }

  render() {
    return (
      <section class="h-auto bg-opacity-50">
        <div class="md:w-4/4 container max-w-4xl ">
          <div class="space-y-6 bg-white">
            <div class="w-full items-center space-y-4 p-4 text-gray-500 md:inline-flex md:space-y-0">
              <h2 class="text-blue-gray-900 mx-auto max-w-sm font-semibold capitalize md:w-1/3">
                Account
              </h2>
              <div class="mx-auto max-w-sm space-y-5 md:w-2/3 ">
                <div>
                  <label class="text-blue-gray-900 text-sm font-semibold capitalize">
                    About You
                  </label>
                  <div class="inline-flex w-full border">
                    <textarea
                      type="text"
                      class="text-blue-gray-500 block h-40 w-11/12 p-2 font-sans text-sm font-normal leading-normal antialiased focus:text-gray-600 focus:outline-none"
                      placeholder="Introduce Something About You"
                      id="user_paragraph_form"
                    />
                  </div>
                </div>
                <div>
                  <label class="text-blue-gray-900 text-sm font-semibold capitalize">
                    Hightlight
                  </label>
                  <div class="inline-flex w-full border">
                    <div class="w-1/12 bg-gray-100 pt-2">
                      <svg
                        fill="none"
                        class="mx-auto w-6 text-gray-400"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M12 18v-5.25m0 0a6.01 6.01 0 001.5-.189m-1.5.189a6.01 6.01 0 01-1.5-.189m3.75 7.478a12.06 12.06 0 01-4.5 0m3.75 2.383a14.406 14.406 0 01-3 0M14.25 18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 10-7.517 0c.85.493 1.509 1.333 1.509 2.316V18"
                        />
                      </svg>
                    </div>
                    <input
                      type="text"
                      class="text-blue-gray-500 block w-11/12 p-2 font-sans text-sm font-normal leading-normal antialiased focus:text-gray-600 focus:outline-none"
                      placeholder="What is your user paragraph"
                      id="highLight"
                    />
                  </div>
                </div>
                {this.state.IsChristian ? (
                  <div>
                    <label class="text-blue-gray-900 text-sm font-semibold capitalize">
                      Bible Text
                    </label>
                    <div className="mt-2" id="i_bibleVerse"></div>
                    <button
                      class="float-right mx-auto mt-4 inline-flex max-w-sm items-center rounded-md bg-indigo-400 px-4 py-2 text-center text-white focus:outline-none md:float-right"
                      onClick={this.update_bibleVerse}
                    >
                      Change Bible Verse
                    </button>
                  </div>
                ) : (
                  <div>
                    <label class="text-blue-gray-900 text-sm font-semibold capitalize">
                      Quotes
                    </label>
                    <div className="mt-2" id="i_quotes"></div>
                    <button
                      class="float-right mx-auto mt-4 inline-flex max-w-sm items-center rounded-md bg-indigo-400 px-4 py-2 text-center text-white focus:outline-none md:float-right"
                      onClick={this.update_Quotes}
                    >
                      Change Quotes
                    </button>
                  </div>
                )}
              </div>
            </div>

            <hr class="border-gray-300" />
            <div class="w-full  items-center space-y-4  p-4 text-gray-500 md:inline-flex md:space-y-0">
              <h2 class="text-blue-gray-900 mx-auto max-w-sm font-semibold capitalize md:w-1/3">
                Personal info
              </h2>
              <div class="mx-auto max-w-sm space-y-5 md:w-2/3">
                <div>
                  <label class="text-blue-gray-900 text-sm font-semibold capitalize ">
                    Full name
                  </label>
                  <div class="inline-flex w-full border">
                    <div class="w-1/12 bg-gray-100 pt-2">
                      <svg
                        fill="none"
                        class="mx-auto w-6 text-gray-400"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                        />
                      </svg>
                    </div>
                    <input
                      type="text"
                      class="text-blue-gray-500 block w-11/12 p-2 font-sans text-sm font-normal leading-normal antialiased focus:text-gray-600 focus:outline-none"
                      placeholder="Charly Olivas"
                      id="fullname"
                      readOnly
                    />
                  </div>
                </div>
                <div>
                  <label class="text-blue-gray-900 text-sm font-semibold capitalize">
                    Email
                  </label>
                  <div class="inline-flex w-full border">
                    <div class="w-1/12 bg-gray-100 pt-2">
                      <svg
                        fill="none"
                        class="mx-auto w-6 text-gray-400"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          d="M16.5 12a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm0 0c0 1.657 1.007 3 2.25 3S21 13.657 21 12a9 9 0 10-2.636 6.364M16.5 12V8.25"
                        />
                      </svg>
                    </div>
                    <input
                      type="text"
                      class="text-blue-gray-500 block w-11/12 p-2 font-sans text-sm font-normal leading-normal antialiased focus:text-gray-600 focus:outline-none"
                      placeholder="12341234"
                      id="email"
                      readOnly
                    />
                  </div>
                </div>
                <div>
                  <label class="text-blue-gray-900 text-sm font-semibold capitalize">
                    Location
                  </label>
                  <div class="inline-flex w-full border">
                    <div class="w-1/12 bg-gray-100 pt-2">
                      <svg
                        fill="none"
                        class="mx-auto w-6 text-gray-400"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
                        />
                      </svg>
                    </div>
                    <input
                      type="text"
                      class="text-blue-gray-500 block w-11/12 p-2 font-sans text-sm font-normal leading-normal antialiased focus:text-gray-600 focus:outline-none"
                      placeholder="12341234"
                      id="i_location"
                    />
                  </div>
                </div>
              </div>
            </div>
            <hr class="border-gray-500" />
            <div class="w-full items-center space-y-4 p-4 text-gray-500 md:inline-flex md:space-y-0">
              <h2 class="text-blue-gray-900 mx-auto max-w-sm font-semibold capitalize md:w-1/3">
                Account Picture
              </h2>
              <div class="mx-auto max-w-sm space-y-5 md:w-2/3 ">
                <div>
                  <label class="text-blue-gray-900 text-sm font-semibold capitalize">
                    Profile Picture
                  </label>
                  <div id="i_profile">
                    <p id="i_profile_A">Current.jpg</p>
                  </div>
                  <button
                    class="float-right mx-auto inline-flex max-w-sm items-center rounded-md bg-indigo-400 px-4 py-2 text-center text-white focus:outline-none md:float-right"
                    onClick={this.update_profile}
                  >
                    Change
                  </button>
                </div>
                <div>
                  <label class="text-blue-gray-900 text-sm font-semibold capitalize">
                    Profile Background Picture
                  </label>

                  <div id="i_profile">
                    <p id="i_profile_B">Current_Background.jpg</p>
                  </div>
                  <button
                    class="float-right mx-auto inline-flex max-w-sm items-center rounded-md bg-indigo-400 px-4 py-2 text-center text-white focus:outline-none md:float-right"
                    onClick={this.update_background}
                  >
                    Change
                  </button>
                </div>
              </div>
            </div>
            <hr class="border-gray-500" />
            <div class="flex w-full justify-end p-4 text-right text-gray-500">
              <div class="text-center md:w-3/12 md:pl-6">
                <button
                  class="mx-auto inline-flex w-full max-w-sm items-center rounded-md bg-indigo-400 px-4 py-2 text-center text-white focus:outline-none md:float-right"
                  onClick={this.finishing}
                  style={{ display: this.state.display }}
                >
                  <svg
                    fill="none"
                    class="mr-2 w-4 text-white"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                    />
                  </svg>
                  Update
                </button>
                <button
                  disabled
                  type="button"
                  class="float-right mr-2 inline-flex items-center rounded-lg border border-gray-200 bg-white px-5 py-2.5 text-sm font-medium text-gray-900 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:text-blue-700 focus:ring-2 focus:ring-blue-700 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                  id="finished_button"
                  style={{ display: this.state.loading_display }}
                >
                  <svg
                    aria-hidden="true"
                    role="status"
                    class="mr-3 inline h-4 w-4 animate-spin text-gray-200 dark:text-gray-600"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="currentColor"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="#1C64F2"
                    />
                  </svg>
                  Loading...
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
